import angular from 'angular';
import uiRouter from 'angular-ui-router';
import reportsComponent from './reports.component';

// Reports
import Executivesummary from '../../common/reports/executivesummary/executivesummary';
import Episodelist from '../../common/reports/episodelist/episodelist';
import Changespercoder from '../../common/reports/changespercoder/changespercoder';
import Commondrgchanges from '../../common/reports/commondrgchanges/commondrgchanges';
import Commonicdchanges from '../../common/reports/commonicdchanges/commonicdchanges';
import Commonicdchangesbydrg from '../../common/reports/commonicdchangesbydrg/commonicdchangesbydrg';
import Commonchangedtodrg from '../../common/reports/commonchangedtodrg/commonchangedtodrg';
import Awaitingreview from '../../common/reports/awaitingreview/awaitingreview';
import Queries from '../../common/reports/queries/queries';
import Querychanges from '../../common/reports/querychanges/querychanges';
import SentQueries from '../../common/reports/sentqueries/sentqueries';
import Mechvent from '../../common/reports/mechvent/mechvent';
import Atsi from '../../common/reports/atsi/atsi';
import Unitaudit from '../../common/reports/unitaudit/unitaudit';
import Totalaudit from '../../common/reports/totalaudit/totalaudit';
import Auditsbymonth from '../../common/reports/auditsbymonth/auditsbymonth';
import Auditprogress from '../../common/reports/auditprogress/auditprogress';
import Codedmedicalrecords from '../../common/reports/codedmedicalrecords/codedmedicalrecords';
import Coderreviewed from '../../common/reports/coderreviewed/coderreviewed';
import Targetdrgs from '../../common/reports/targetdrgs/targetdrgs';
import Picq from '../../common/reports/picq/picq';
import Auditresultsummary from '../../common/reports/auditresultsummary/auditresultsummary';
import Incompletedocumentation from '../../common/reports/incompletedocumentation/incompletedocumentation';
import Codingactivity from '../../common/reports/codingactivity/codingactivity';
import Readmissions from '../../common/reports/readmissions/readmissions';
import Episodechangereport from '../../common/reports/episodechangereport/episodechangereport';
import Auditprogramdrgchanges from '../../common/reports/auditprogramdrgchanges/auditprogramdrgchanges';
import Auditprogramresults from '../../common/reports/auditprogramresults/auditprogramresults';
import ExecutivesummaryPOC from '../../common/reports/executivesummary_poc/executivesummary.poc';

let reportsModule = angular.module('reports', [
  uiRouter,
  Executivesummary.name,
  Episodelist.name,
  Changespercoder.name,
  Commondrgchanges.name,
  Commonicdchanges.name,
  Commonicdchangesbydrg.name,
  Commonchangedtodrg.name,
  Queries.name,
  Awaitingreview.name,
  Querychanges.name,
  SentQueries.name,
  Mechvent.name,
  Atsi.name,
  Unitaudit.name,
  Totalaudit.name,
  Auditsbymonth.name,
  Auditprogress.name,
  Codedmedicalrecords.name,
  Coderreviewed.name,
  Targetdrgs.name,
  Picq.name,
  Auditresultsummary.name,
  Incompletedocumentation.name,
  Codingactivity.name,
  Readmissions.name,
  Episodechangereport.name,
  Auditprogramdrgchanges.name,
  Auditprogramresults.name,
  ExecutivesummaryPOC.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider

  .state('reports', {
    url: '/reports',
    template: '<reports></reports>',
    authenticate: true
  })

  .state('reports.episodelist', {
    url: '/episodelist',
    template: '<episodelist></episodelist>',
    authenticate: true
  })

  .state('reports.changespercoder', {
    url: '/changespercoder',
    template: '<changespercoder></changespercoder>',
    authenticate: true
  })

  .state('reports.commondrgchanges', {
    url: '/commondrgchanges',
    template: '<commondrgchanges></commondrgchanges>',
    authenticate: true
  })

  .state('reports.commonicdchanges', {
    url: '/commonicdchanges',
    template: '<commonicdchanges></commonicdchanges>',
    authenticate: true
  })

  .state('reports.commonicdchangesbydrg', {
    url: '/commonicdchangesbydrg',
    template: '<commonicdchangesbydrg></commonicdchangesbydrg>',
    authenticate: true,
    params: {
        drg: {
          value: '0',
          squash: false
        },
        specialty: {
          value: '0',
          squash: false
        },
        startDate: {
          value: '0',
          squash: false
        },
        endDate: {
          value: '0',
          squash: false
        }
      }
  })

  .state('reports.executivesummary', {
    url: '/executive-summary',
    template: '<executivesummary></executivesummary>',
    authenticate: true
  })

  .state('reports.executivesummary-auditing', {
    url: '/executive-summary-auditing',
    template: '<executivesummarypoc></executivesummarypoc>',
    authenticate: true
  })

  .state('reports.commonchangedtodrg', {
    url: '/commonchangedtodrg',
    template: '<commonchangedtodrg></commonchangedtodrg>',
    authenticate: true
  })

  .state('reports.awaitingreview', {
    url: '/awaitingreview',
    template: '<awaitingreview></awaitingreview>',
    authenticate: true
  })

  .state('reports.queries', {
    url: '/queries',
    template: '<queries></queries>',
    authenticate: true
  })

  .state('reports.querychanges', {
    url: '/querychanges',
    template: '<querychanges></querychanges>',
    authenticate: true
  })

  .state('reports.mechvent', {
    url: '/mechanical-ventilation',
    template: '<mechvent></mechvent>',
    authenticate: true
  })

  .state('reports.atsi', {
    url: '/atsi',
    template: '<atsi></atsi>',
    authenticate: true
  })

  .state('reports.unitaudit', {
    url: '/unit-audit',
    template: '<unitaudit></unitaudit>',
    authenticate: true
  })

  .state('reports.totalaudit', {
    url: '/total-audit',
    template: '<totalaudit></totalaudit>',
    authenticate: true
  })

  .state('reports.auditsbymonth', {
    url: '/audits-by-month',
    template: '<auditsbymonth></auditsbymonth>',
    authenticate: true
  })

  .state('reports.auditprogress', {
    url: '/audit-progress',
    template: '<auditprogress></auditprogress>',
    authenticate: true
  })

  .state('reports.codedmedicalrecords', {
    url: '/coded-medical-records',
    template: '<codedmedicalrecords></codedmedicalrecords>',
    authenticate: true
  })

  .state('reports.codingreview', {
    url: '/codingreview',
    template: '<coderreviewed></coderreviewed>',
    authenticate: true
  })

  .state('reports.targetdrgs', {
    url: '/target-drgs',
    template: '<targetdrgs></targetdrgs>',
    authenticate: true
  })

  .state('reports.picq', {
    url: '/picq',
    template: '<picq></picq>',
    authenticate: true
  })

  .state('reports.auditresultsummary', {
    url: '/audit-result-summary',
    template: '<auditresultsummary></auditresultsummary>',
    authenticate: true
  })

  .state('reports.incompletedocumentation', {
    url: '/incompletedocumentation',
    template: '<incompletedocumentation></incompletedocumentation>',
    authenticate: true
  })

  .state('reports.codingactivity', {
    url: '/coding-activity',
    template: '<codingactivity></codingactivity>',
    authenticate: true
  })

  .state('reports.readmissions', {
    url: '/readmissions',
    template: '<readmissions></readmissions>',
    authenticate: true
  })

  .state('reports.episodechangereport', {
    url: '/episodechangereport',
    template: '<episodechangereport></episodechangereport>',
    authenticate: true
  })

  .state('reports.sentqueries', {
    url: '/sentqueries',
    template: '<sentqueries></sentqueries>',
    authenticate: true
  })

  .state('reports.auditprogramdrgchanges', {
    url: '/audited-medical-drg-records',
    template: '<auditprogramdrgchanges></auditprogramdrgchanges>',
    authenticate: true
  })

  .state('reports.auditprogramresults', {
    url: '/audit-program-results',
    template: '<auditprogramresults></auditprogramresults>',
    authenticate: true
  });
})

.component('reports', reportsComponent);

export default reportsModule;



// WEBPACK FOOTER //
// ./client/app/components/reports/reports.js